<template>
    <form
        class="needs-validation"
        id="contact-form"
        novalidate
        ref="contactForm"
        :class="validationErrorClass"
        @submit.prevent="submit">
        <div class="row gx-3">
            <div class="col-md-6">
                <label for="first-name" class="form-label required">{{ 'common.form-first-name' | l }}</label>
                <input
                    required
                    type="text"
                    class="form-control"
                    id="first-name"
                    v-model="formData.firstName"
                    :pattern="patterns.alphaDash">
            </div>
            <div class="col-md-6">
                <label for="last-name" class="form-label required">{{ 'common.form-last-name' | l }}</label>
                <input
                    required
                    type="text"
                    class="form-control"
                    id="last-name"
                    v-model="formData.lastName"
                    :pattern="patterns.alphaDash">
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md-6">
                <label for="company" class="form-label required">{{ 'common.form-company-name' | l }}</label>
                <input
                    required
                    type="text"
                    class="form-control"
                    id="company"
                    v-model="formData.company">
            </div>
            <div class="col-md-6">
                <label for="company-size" class="form-label required">{{ 'common.form-company-size' | l }}</label>
                <select
                    required
                    class="form-control form-select"
                    id="company-size"
                    :aria-label="'common.form-company-size' | l"
                    v-model="formData.companySize">
                    <option v-for="size in companySizes" :value="size.value">{{ size.label }}</option>
                </select>
            </div>
        </div>
        <div>
            <label for="email" class="form-label required">{{ 'common.form-email' | l }}</label>
            <input
                required
                type="text"
                class="form-control"
                id="email"
                v-model="formData.email"
                :pattern="patterns.email">
        </div>
        <div>
            <label for="subject" class="form-label required">{{ 'common.form-subject' | l }}</label>
            <select
                required
                class="form-control form-select"
                id="subject"
                :aria-label="'common.form-subject' | l"
                v-model="formData.subject">
                <option v-for="subject in subjects" :value="subject.value">{{ subject.label }}</option>
            </select>
        </div>
        <div class="mb-2">
            <label for="send-us-message" class="form-label required">{{ 'common.form-message' | l }}</label>
            <textarea
                required
                class="form-control send-us-message mt-0"
                id="send-us-message"
                v-model="formData.message"
                cols="30"
                rows="10"
                minlength="60"
                maxlength="550"
            ></textarea>
        </div>

        <button
            type="submit"
            class="btn btn-primary btn-send-us-message mt-5"
            :class="{'disabled': isSubmitting, 'submitting': isSubmitting}">
            <button-loader v-if="isSubmitting"></button-loader>
            {{ 'common.form-send-message' | l }}
        </button>
    </form>
</template>

<script>
    import Repository from '../repositories/Repository';

    export default {
        name: 'ContactForm',
        props: {
            submitUrl: {
                type: String,
                default: ''
            },
            companySizes: {
                type: Array,
                default: function () {
                    return [
                        {value: '1-10 employees', label: '1-10 employees'},
                        {value: '11-50 employees', label: '11-50 employees'},
                        {value: '51-250 employees', label: '51-250 employees'},
                        {value: '251-1000 employees', label: '251-1000 employees'},
                        {value: '1000+ employees', label: '1000+ employees'}
                    ]
                }
            },
            subjects: {
                type: Array,
                default: function () {
                    return [
                        {value: 'Sellers software module', label: 'Sellers software module'},
                        {value: 'CRM software module', label: 'CRM software module'},
                        {value: 'Service Provider Marketplace', label: 'Service Provider Marketplace'},
                        {value: 'Partnership', label: 'Partnership'},
                        {value: 'Other', label: 'Other'}
                    ]
                }
            },
        },
        data() {
            return {
                formData: {
                    firstName: null,
                    lastName: null,
                    company: null,
                    companySize: null,
                    email: null,
                    subject: null,
                    message: null,
                    recaptchaToken: null
                },
                recaptchaSiteKey: window.Evat.data.googleRecaptchaSiteKey,
                isSubmitting: false,
                validationErrorClass: '',
                patterns: window.patterns
            }
        },
        mounted() {
        },
        methods: {
            async submit(e) {
                this.isSubmitting = true;
                let valid = await this.isValid();
                if (!valid) {
                    this.isSubmitting = false;
                    return;
                }

                await this.$recaptchaLoaded();
                this.formData.recaptchaToken = await this.$recaptcha('contact');
                let resp = await Repository.post(this.submitUrl, this.formData);
                if (resp && resp.success && resp.to) {
                    redirect(resp.to);
                }
            },
            async isValid() {
                this.validationErrorClass = 'was-validated';
                return this.$refs.contactForm.checkValidity();
            },
            isFiled(model) {
                if (!model) {
                    model = '';
                }

                return model.trim().length;
            }
        }
    }
</script>
